import React, { useEffect, useState } from 'react'
import { useGetDestinationQuery, useGetTagsQuery, useAddPackingListMutation, useEditPackingListMutation, useLazyGetPackingListByIdQuery, usePackingDefaultGetQuery } from '../../../../services/Api';
import { toast } from 'react-toastify';
import AddPackingListStep1 from './addPackingList';
import WidgetManager from './widgetForms';
import WidgetManagerBottom from './widgetBottom'
import { useNavigate, useParams } from 'react-router-dom';

const AddPackingListMain = ({ editPacking }) => {
    const [step, setStep] = useState(1);
    const { data, isLoading: packingLoading } = usePackingDefaultGetQuery()
    const { id } = useParams()
    const navigate = useNavigate();
    const [imagePreview, setImagePreview] = useState(null);
    const [creatorImagePreview, setCreatorImagePreview] = useState(null);
    const [videoPreview, setVideoPreview] = useState(null);
    const [formDataForm, setFormData] = useState({
        step1: {},
        step2: {},
        step3: {}
    });
    const [trigger, { data: productData, isLoading: loading, error }] = useLazyGetPackingListByIdQuery();
    // const [trigger, { data: productData, }] = useLazyGetPackingListByIdQuery()
    const [widgets, setWidgets] = useState(formDataForm.step2 && formDataForm.step2.widgets || [
        // {
        //     type: "quickTrip",
        //     name: "My Quick Trip Bag",
        //     url: "",
        //     image: "",
        //     items: [
        //         // { name: "T-Shirts", quantity: 1, notes: "Comfortable ones", url: '', isDiscover: false }
        //     ],
        // },
    ]);
    const [widgetData, setWidgetData] = useState({
        laundryBag: {
            type: "pro",
            name: "compression",
            description: "",
            laundryBagImage: "",
            url: "",
        },
        travelPack: {
            type: "regular",
            size: "40L",
            travelPackImage: "",
            url: "",
            description: "",
            name: ''
        },
        dayPack: {
            type: "regular",
            size: "20L",
            dayPackImage: "",
            url: "",
            description: "",
            name: ''
        },
        hipPack: {
            type: "regular",
            size: "3L",
            hipPackImage: "",
            url: "",
            description: "",
            name: ''
        },

    });
    useEffect(() => {
        if (id != undefined && editPacking == true) {
            trigger(id && id)
        }
    }, [id, editPacking])
    useEffect(() => {
        if (productData != undefined) {
            setFormData({ step1: productData })
            setWidgets(productData?.data?.widgets)
            setWidgetData({
                laundryBag: productData?.data?.laundryBag,
                travelPack: productData?.data?.travelPack,
                dayPack: productData?.data?.dayPack,
                hipPack: productData?.data?.hipPack,
            })
        }
    }, [JSON.stringify(productData)])
    useEffect(() => {
        if (data != undefined) {
            const preData = data && data[0]
            setWidgetData({
                laundryBag: preData?.laundryBag,
                travelPack: preData?.travelPack,
                dayPack: preData?.dayPack,
                hipPack: preData?.hipPack,
            })
        }
    }, [JSON.stringify(data)])
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [addPackingList] = useAddPackingListMutation()
    const [editPackingList] = useEditPackingListMutation()
    const handleNext = (data, isValid) => {
        if (isValid) {
            setFormData(prev => ({ ...prev, [`step${step}`]: data }));
            setStep(prev => prev + 1);
        }
    };
    const handleBack = () => setStep(prev => prev - 1);
    const handleSubmit = (data) => {
        const mergedData = { step3: data };
        const mainMergeData = { ...formDataForm?.step1?.data, ...formDataForm?.step2, ...mergedData?.step3?.widgetData }
        const dataForm = {
            type: mainMergeData?.type,
            title: mainMergeData?.title,
            creator: mainMergeData?.creator,
            thumbnail: mainMergeData?.thumbnail,
            creatorImage: mainMergeData?.creatorImage,
            youtubeUrl: mainMergeData?.youtubeUrl,
            description: mainMergeData?.description,
            duration: mainMergeData?.duration,
            bodyType: mainMergeData?.bodyType,
            packingStyle: mainMergeData?.packingStyle,
            activityScale: mainMergeData?.activityScale,
            toiletry: mainMergeData?.toiletry,
            laundryBagImage: mainMergeData?.laundryBag?.laundryBagImage || null,
            travelPackImage: mainMergeData?.travelPack?.travelPackImage || null,
            dayPackImage: mainMergeData?.dayPack?.dayPackImage || null,
            hipPackImage: mainMergeData?.hipPack?.hipPackImage || null,
            destinations: JSON.stringify(mainMergeData?.destinations),
            climate: JSON.stringify(mainMergeData?.climate),
            // tech: JSON.stringify(mainMergeData?.tech),
            // tags: JSON.stringify(mainMergeData?.tags),
            widgets: JSON.stringify(mainMergeData?.widgets),
            // laundryBag: { type: mainMergeData?.laundryBag?.type, name: mainMergeData?.laundryBag?.name, url: mainMergeData?.laundryBag?.url },
            // travelPack: JSON.stringify(mainMergeData?.travelPack),
            // dayPack: JSON.stringify(mainMergeData?.dayPack),
            // hipPack: JSON.stringify(mainMergeData?.hipPack)
            // destinations: [
            //     {
            //         "region": "",
            //         "country": "Albania",
            //         "state": "",
            //         "city": ""
            //     },
            //     {
            //         "region": "",
            //         "country": "Andorra",
            //         "state": "",
            //         "city": ""
            //     }
            // ],
            // destinations: mainMergeData?.destinations?.flat() || [],
            // climate: mainMergeData?.climate,
            tech: mainMergeData?.tech,
            tags: mainMergeData?.tags,
            video: mainMergeData?.video || null,
            // widgets: mainMergeData?.widgets,
            laundryBag: JSON.stringify({ type: mainMergeData?.laundryBag?.type, name: mainMergeData?.laundryBag?.name, description: mainMergeData?.laundryBag?.description, url: mainMergeData?.laundryBag?.url }),
            travelPack: JSON.stringify({ type: mainMergeData?.travelPack?.type, size: mainMergeData?.travelPack?.size, name: mainMergeData?.travelPack?.name, description: mainMergeData?.travelPack?.description, url: mainMergeData?.travelPack?.url }),
            dayPack: JSON.stringify({ type: mainMergeData?.dayPack?.type, size: mainMergeData?.dayPack?.size, name: mainMergeData?.dayPack?.name, description: mainMergeData?.dayPack?.description, url: mainMergeData?.dayPack?.url }),
            hipPack: JSON.stringify({ type: mainMergeData?.hipPack?.type, size: mainMergeData?.hipPack?.size, name: mainMergeData?.hipPack?.name, description: mainMergeData?.hipPack?.description, url: mainMergeData?.hipPack?.url }),
            // travelPack: mainMergeData?.travelPack,
            // dayPack: mainMergeData?.dayPack,
            // hipPack: mainMergeData?.hipPack
        };
        const formData = new FormData();
        // const dataForm = jsonToFormData(mainMergeData)
        Object.entries(dataForm).forEach(([key, value]) => {
            formData.append(key, value);
        });
        // formData.append('tech[]', mainMergeData?.tech);
        // formData.append('tags[]', mainMergeData?.tags);

        if (editPacking) {
            setIsSubmitting(true)
            editPackingList({ id: id, data: formData })
                .unwrap()
                .then((payload) => {
                    if (payload.success) {
                        navigate('/packing')
                        toast.success("Package Listing Updated Successfully");
                        setIsSubmitting(false)
                    } else {
                        toast.error(payload?.message);
                    }
                })
                .catch((error) => {
                    toast.error(error?.data?.message);
                    setIsSubmitting(false)
                });
        } else {
            setIsSubmitting(true)
            addPackingList({ data: formData })
                .unwrap()
                .then((payload) => {
                    if (payload.success) {
                        navigate('/packing')
                        toast.success("Package Listing Updated Successfully");
                        setIsSubmitting(false)
                    } else {
                        toast.error(payload?.message);
                    }
                })
                .catch((error) => {
                    toast.error(error?.data?.message);
                    setIsSubmitting(false)
                });
        }

        // Handle submission logic here
    };
    return (
        <div className='min-h-screen p-4 md:p-8' >
            <h1 className="text-black font-['Roboto_Mono'] text-2xl font-bold text-center "> Add Packing List </h1>
            <div className="flex items-center justify-between w-full max-w-3xl mx-auto my-12">
                {/* Step 1 */}
                <div className="relative flex items-center">
                    <div className={`w-8 h-8 flex items-center justify-center rounded-full border-2 z-10 border-[#D9DCB0] ${step == 1 ? 'bg-bgprimary text-white' : 'bg-white text-bgprimary'}`}>
                        {step == 1 ? '1' : step > 1 ?
                            <>
                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18.3333 7L9.16667 16.1667L5 12" stroke="#D9DCB0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                            </> : '1'
                        }

                    </div>
                    <div className="absolute left-8 top-1/2 w-[23rem] h-[2px] bg-[#D9DCB0]"></div>
                </div>

                {/* Step 2 */}
                <div className="relative flex items-center">
                    <div className={`w-8 h-8 flex items-center justify-center rounded-full border-2 z-10 border-[#D9DCB0] ${step == 2 ? 'bg-bgprimary text-white' : 'bg-white text-bgprimary'}`}>
                        {step == 2 ? '2' : step > 2 ? <>
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18.3333 7L9.16667 16.1667L5 12" stroke="#D9DCB0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                        </> : '2'
                        }

                    </div>
                    <div className="absolute left-8 top-1/2 w-[23rem] h-[2px] bg-[#D9DCB0]"></div>
                </div>

                {/* Step 3 (Active) */}
                <div className={`w-8 h-8 flex items-center justify-center rounded-full border-2 z-10 border-[#D9DCB0] ${step == 3 ? 'bg-bgprimary text-white' : 'bg-white text-bgprimary'}`}>
                    {step == 3 ? '3' : step > 3 ? <>
                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.3333 7L9.16667 16.1667L5 12" stroke="#D9DCB0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                    </> : '3'
                    }

                </div>
            </div>


            {step === 1 ? (
                <AddPackingListStep1
                    onNext={handleNext}
                    data={formDataForm.step1}
                    imagePreview={imagePreview}
                    setImagePreview={setImagePreview}
                    videoPreview={videoPreview}
                    setVideoPreview={setVideoPreview}
                    editPacking={editPacking}
                    setCreatorImagePreview={setCreatorImagePreview}
                    creatorImagePreview={creatorImagePreview}
                />
            ) : step === 2 ? (
                <WidgetManager
                    onNext={handleNext}
                    onBack={handleBack}
                    widgets={widgets}
                    setWidgets={setWidgets}
                    data={formDataForm.step2}
                    preData={data && data[0]?.widgets}
                />
            ) : step === 3 && (
                <WidgetManagerBottom
                    onSubmit={handleSubmit}
                    isSubmitting={isSubmitting}
                    onBack={handleBack}
                    widgetData={widgetData}
                    setWidgetData={setWidgetData}
                    data={formDataForm.step3}
                />
            )}

        </div>
    )
}

export default AddPackingListMain
